import { useMutation, useQueryClient } from '@tanstack/react-query';
import { regionsApi } from '../api/regions.api';
import type { UpdateRegionRequest } from '../types/regions.types';
import { isRegionHierarchyQuery } from './isRegionHierarchyQuery';
import { regionKeys } from './queryKeys';

export const useUpdateRegion = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateRegionRequest }) =>
      regionsApi.updateRegion(id, data),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: regionKeys.lists() });
      queryClient.invalidateQueries({ queryKey: regionKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: regionKeys.tree() });
      queryClient.invalidateQueries({ queryKey: regionKeys.byCountryAndTypeAll() });
      // Also invalidate RegionHierarchyInput's own cache — the parent-region picker
      // actually used in production, keyed independently of regionKeys (see
      // isRegionHierarchyQuery.ts for why a predicate is needed here).
      queryClient.invalidateQueries({ predicate: isRegionHierarchyQuery });
    },
  });

  return {
    updateRegion: mutation.mutate,
    isUpdating: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
